export default function checkout() {
    if ( ! document.querySelector( 'form.woocommerce-checkout' ) ) return;

    function updateOrderReview() {
        if ( typeof wc_checkout_params === 'undefined' ) return;

        jQuery.ajax( {
            type: 'POST',
            url: wc_checkout_params.wc_ajax_url.replace( '%%endpoint%%', 'update_order_review' ),
            data: jQuery( 'form.woocommerce-checkout' ).serialize()
                + '&security=' + wc_checkout_params.update_order_review_nonce,
            success: function ( data ) {
                if ( ! data.fragments ) return;
                jQuery.each( data.fragments, function ( key, value ) {
                    jQuery( key ).replaceWith( value );
                } );
            },
        } );
    }

    // Shipping method change — send full form + recalculate
    jQuery( document.body ).on( 'change', '#wc__checkout-shipping-methods input.shipping_method', updateOrderReview );

    // Payment method change — show/hide description box + recalculate
    jQuery( document.body ).on( 'change', '#wc__checkout-payment-methods input[name="payment_method"]', function () {
        jQuery( document.body ).trigger( 'payment_method_selected' );
        updateOrderReview();
    } );

    // Apply coupon — own AJAX call, a nested <form> inside the checkout form is not allowed
    function applyCoupon() {
        if ( typeof wc_checkout_params === 'undefined' ) return;

        const $input   = jQuery( '#wc__checkout-coupon-code' );
        const $button  = jQuery( '[data-action="apply_wc_checkout_coupon"]' );
        const $message = jQuery( '.wc__checkout-coupon-message' );
        const code     = $input.val().trim();

        if ( ! code ) {
            $input.trigger( 'focus' );
            return;
        }

        $button.prop( 'disabled', true );
        $message.empty();

        jQuery.ajax( {
            type: 'POST',
            url: wc_checkout_params.wc_ajax_url.replace( '%%endpoint%%', 'apply_coupon' ),
            data: {
                security: wc_checkout_params.apply_coupon_nonce,
                coupon_code: code,
            },
            dataType: 'html',
            success: function ( response ) {
                $message.html( response );

                if ( response.indexOf( 'woocommerce-error' ) === -1 ) {
                    $input.val( '' );
                    jQuery( document.body ).trigger( 'applied_coupon_in_checkout', [ code ] );
                    jQuery( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );
                }
            },
            complete: function () {
                $button.prop( 'disabled', false );
            },
        } );
    }

    jQuery( document.body ).on( 'click', '[data-action="apply_wc_checkout_coupon"]', applyCoupon );

    // Enter in the coupon field must not submit the order
    jQuery( document.body ).on( 'keydown', '#wc__checkout-coupon-code', function ( e ) {
        if ( e.key !== 'Enter' ) return;
        e.preventDefault();
        applyCoupon();
    } );

    // Toggle cart item variation details
    jQuery( document.body ).on( 'click', '[data-action="toggle_wc_checkout_item_variation"]', function () {
        const $toggle    = jQuery( this );
        const $item      = $toggle.closest( '.wc__checkout-table-item' );
        const $variation = $item.find( '.variation' );
        const $svg       = $toggle.find( 'svg' );
        const isOpen     = $item.hasClass( 'is-open' );

        if ( isOpen ) {
            $variation.stop().animate( { height: '0' }, 300, function () {
                $item.removeClass( 'is-open' );
            } );
        } else {
            $item.addClass( 'is-open' );
            const height = $variation[ 0 ].scrollHeight;
            $variation.css( 'height', '0' ).stop().animate( { height: height + 'px' }, 300 );
        }

        $toggle.toggleClass( 'is-active' );
    } );
}